export const PRODUCT_PRESET_SUBTYPE_CATALOG_VERSION = '2026-08-25.v1';

export type ProductPresetSubtype = {
  id: string;
  label: string;
  description: string;
  imageUrl?: string;
  invariants: readonly [string, string, ...string[]];
};

export type ProductPresetSubtypeCatalog = {
  parentKey: string;
  parentNames: readonly [string, ...string[]];
  subtypes: readonly ProductPresetSubtype[];
};

export type ProductPresetSubtypeSelection<
  TProductPresetId extends string = string,
> = {
  productPresetId: TProductPresetId;
  subtypeId: string;
};

export function normalizeProductPresetSubtypeSelections<
  TProductPresetId extends string,
>(
  selections: ReadonlyArray<ProductPresetSubtypeSelection<TProductPresetId>>
): Array<ProductPresetSubtypeSelection<TProductPresetId>> {
  const seen = new Set<string>();
  const normalized: Array<ProductPresetSubtypeSelection<TProductPresetId>> = [];

  for (const selection of selections) {
    const key = `${selection.productPresetId}\u0000${selection.subtypeId}`;
    if (seen.has(key)) continue;
    seen.add(key);
    normalized.push(selection);
  }

  return normalized;
}

export function isProductPresetSubtypeSelection(
  value: unknown
): value is ProductPresetSubtypeSelection {
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    typeof (value as { productPresetId?: unknown }).productPresetId ===
      'string' &&
    typeof (value as { subtypeId?: unknown }).subtypeId === 'string'
  );
}

export const PRODUCT_PRESET_SUBTYPE_VARIATION_SCOPE = [
  'Material',
  'Color',
  'Finish',
  'Proportions not fixed by the selected subtype',
  'Surface detail',
] as const;
